import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { DatePicker } from "antd";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import Table from "../../Components/TableTemplate/Table";
import { getRestoLogin, getRole } from "../../Helpers/Utils/Common";
import ExportPDF from "../../Components/Export/ExportPDF";
import { DownloadTableExcel } from "react-export-table-to-excel";
import Select from "react-select";
import { getAllMenuManager } from "../../Helpers/apiCalls/menuManagerApi";
import "jspdf-autotable";
import moment from "moment";

const { RangePicker } = DatePicker;

function InventoryManager() {
  const [inactive, setInactive] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const componentRef = useRef();
  const dateToday = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
    performing: "",
  });
  const [menuItems, setMenuItems] = useState([]);
  const [selected, setSelected] = useState([]);

  const headers = ["Menu Name", "Count", "Price", "Total"];

  async function fetchInventory() {
    setTableData([]);
    setShowLoader(true)
    const response = await UseGetRequest(
      "reports/stockin",
      { ...filter, menu_id: selected.id },
      getRestoLogin()
    );
    if (response.data) {
      setTableData(response.data.message.datas);
    }
    setShowLoader(false)
  }

  async function fetchMenu() {
    setMenuItems([]);
    const response = await getAllMenuManager(getRestoLogin());
    if (response.data) {
      let categories = response.data.data.menus;
      categories.map((item) => {
        item.products.map((info) => {
          info.category_id = item.category_id;
          info.category_name = item.category_name;
          info.value = info.id;
          info.label = info.name;
          setMenuItems((prev) => [...prev, info]);
        });
      });
    } else {
      setMenuItems([]);
    }
  }

  /** EXPORT */
  function handleToCSV() {
    return (
      <DownloadTableExcel
        filename="Receiving Report"
        sheet="users"
        currentTableRef={componentRef.current}
      >
        <button className="category-new-export-btn">Export to CSV</button>
      </DownloadTableExcel>
    );
  }

  function handlePDF() {
    if (getRole() === "1" || getRole() === "2" || getRole() === "4") {
      return (
        <ExportPDF
          name={"Receiving Report"}
          data={tableData}
          header={headers}
        ></ExportPDF>
      );
    }
  }

  useEffect(() => {
    fetchInventory();
  }, [filter, selected]);

  useEffect(() => {
    fetchMenu();
  }, []);

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"} //Dashboard navbar index
        page={"Reports"}
      />
      <div
        className={`container bold-font ${inactive ? "inactive" : "active"}`}
      >
        <Row className="mb-3">
          <Col xl={6}>
            {/* <h1 className="page-title-menu"> RECEIVING REPORT </h1> */}
            <label className="page-title-menu">RECEIVING REPORT </label>
          </Col>
          <Col xl={3}></Col>
          <Col xl={3}>
            {tableData.length > 0 && (
              <Row>
                <Col>
                  <div className="d-flex justify-content-end">
                    {handleToCSV()}
                  </div>
                </Col>
                <Col>
                  <div className="d-flex justify-content-end pt-1">
                    {handlePDF()}
                  </div>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <hr />
        <div className="table-content">
          <div className="my-2 px-4 PO-filters d-flex">
            {getRole() !== 3 && (
              <Row className="pt-3">
                <Col className="cat-container">
                  <label className="select-label">Filter by Item:</label>
                  <Select
                    className="dropdown-filter me-3"
                    placeholder="Select item..."
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: state.isSelected
                          ? "var(--tertiary-color)"
                          : "var(--tertiary-color)",
                        borderRadius: "7px",
                        border: "0px",
                        minHeight: "20px",
                        maxHeight: "35px",
                        minWidth: "250px",
                        maxWidth: "250px",
                        color: "#1dc369",
                        zIndex: 2,
                      }),
                      input: (baseStyles, state) => ({
                        ...baseStyles,
                        color: state.isSelected ? "white" : "white",
                      }),
                      dropdownIndicator: (baseStyles, state) => ({
                        ...baseStyles,
                        color: "white",
                      }),
                      singleValue: (baseStyles, state) => ({
                        ...baseStyles,
                        color: "white",
                      }),
                      placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        color: "white",
                      }),
                    }}
                    value={selected}
                    options={menuItems}
                    name="menu_items"
                    onChange={setSelected}
                  />
                </Col>
                <Col xs={4}>
                  <RangePicker
                    onChange={(e) => {
                      if (e) {
                        setFilter((prev) => ({
                          ...prev,
                          date_from: e[0].format("YYYY-MM-DD"),
                          date_to: e[1].format("YYYY-MM-DD"),
                        }));
                      } else {
                        setFilter((prev) => ({
                          ...prev,
                          date_from: dateToday,
                          date_to: dateToday,
                        }));
                      }
                    }}
                    placeholder={[dateToday, dateToday]}
                    className="w-100 h-100"
                  />
                </Col>
                {/* <Col className="cat-container">
                  <span className="me-4 align-middle mt-2">
                    &nbsp;&nbsp;&nbsp;&nbsp; Date From:
                  </span>
                  <Form.Control
                    size='sm'
                    type="date"
                    name="date_from"
                    className="date-filter me-3"
                    onChange={handleFilter}
                    value={filter.date_from}
                  />
                </Col>
                <Col className="cat-container">
                  <span className="me-4 align-middle mt-2">Date To:</span>
                  <Form.Control
                    size='sm'
                    type="date"
                    name="date_to"
                    className="date-filter me-3"
                    onChange={handleFilter}
                    value={filter.date_to}
                  />
                </Col> */}
                <Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
              </Row>
            )}
          </div>
          {/* TABLE */}
          <Table
            tableHeaders={["MENU NAME", "DATE RECEIVED", "QTY", "ADDED BY"]}
            headerSelector={["menu", "received_date", "qty", "added_by"]}
            tableData={tableData}
            showLoader={showLoader}
          />
        </div>
        <div style={{ display: "none" }}>
          <Row>
            <div className="row" ref={componentRef}>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text-sales">
                  {window.company_name}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text-sales">
                  {window.company_address}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text-sales">
                  {" "}
                  {window.company_vat_reg_tin}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text-sales">
                  {window.company_min}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text-sales">
                  {window.company_sn}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text-sales">
                  {window.company_ptu_no}
                </label>
              </div>
              <div className="d-flex row justify-content-center">
                <label className="d-flex row justify-content-center print-text-sales">
                  {window.issued_date}
                </label>
              </div>
              <table className="table table-bordered left ms-5 ">
                <thead></thead>
                <tbody>
                  <tr>
                    <th colSpan={3}>OTHER ADJUSTMENTS REPORTS</th>
                  </tr>
                  <tr>
                    <th>MENU NAME</th>
                    <th>DATE RECEIVED</th>
                    <th>QTY</th>
                    <th>ADDED BY</th>
                  </tr>
                  {tableData.map((data) => {
                    return (
                      <tr>
                        <td>{data.menu} </td>
                        <td>{data.received_date}</td>
                        <td>{data.qty} </td>
                        <td>{data.added_by} </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <br></br>
                  </tr>
                  <tr>
                    {/* <th colSpan={3}>GRAND TOTAL PHP {numberFormat(parseFloat(grandTotal).toFixed(2))}                        \</th> */}
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
            </div>
          </Row>
        </div>
      </div>
      <div>
        <label className="powered-label text-center">
          Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
        </label>
      </div>
    </div>
  );
}

export default InventoryManager;
